import * as CONSTANTS from "./constants";

export const containsAudienceSegment = (storeSegments, segment) => {
    if (storeSegments.length > 0) {
        const audienceIndex = storeSegments.findIndex((item) => {
            return item.id === segment;
        });

        return audienceIndex !== -1;
    }
};

export const buttonLink = (props) => {
    const { path, contentId, appDownloaded, deviceType } = props;
    let buttonLink = "";

    switch (deviceType) {
        case "iOS":
            buttonLink = appDownloaded
                ? `${CONSTANTS.IOS_DEEPLINK}${contentId}`
                : CONSTANTS.APPLE_STORE;
            break;
        case "android":
            buttonLink = appDownloaded
                ? `${CONSTANTS.ANDROID_DEEPLINK}${path}`
                : `${CONSTANTS.PLAY_STORE}`;
            break;
        default:
            return buttonLink;
    }
    return buttonLink;
};

export const publishClickedEvent = (setCookieCallback) => {
    setCookieCallback();
    //publish AppCTAClicked event
    if (
        window.CBC &&
        window.CBC.APP &&
        window.CBC.APP.PubSub &&
        window.CBC.APP.PubSub.publish
    ) {
        window.CBC.APP.PubSub.publish(
            "ctaClicked",
            "downloadNewsApp" //ctaName-when multiple CTAs, can use a prop
        );
    }
};
